import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import '@/helpers/str-functions';
import Translate from '@/langs/translate';

Vue.config.productionTip = false;
Vue.mixin(Translate);

new Vue({
    vuetify,
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
